import ToastHighLighter from '@/lib/ToastHighLighter';

export const BadgesCode = () => {
  const language = 'html';
  const codeString = `
  // Title badges
  <h1>
    Example heading <span class="badge bg-secondary">New</span>
  </h1>
  <h2>
    Example heading <span class="badge bg-secondary">New</span>
  </h2>
  <h3>
    Example heading <span class="badge bg-secondary">New</span>
  </h3>
  <h4>
    Example heading <span class="badge bg-secondary">New</span>
  </h4>
  <h5>
    Example heading <span class="badge bg-secondary">New</span>
  </h5>
  <h6>
    Example heading <span class="badge bg-secondary">New</span>
  </h6>
  
  // Button badges
  <button type="button" class="btn btn-primary">
    Notifications <span class="badge bg-secondary">4</span>
  </button>

  <button type="button" class="btn btn-secondary">
    Notifications <span class="badge bg-primary">4</span>
  </button>
  `;

  return (
    <>
      <ToastHighLighter
        name={'badges'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
